import { useResellerBranding } from "@/utils/reseller/store";

const LEGAL_LINKS = [
  {
    label: "Privacy Policy",
    href: "https://www.hotelinking.com/en/terms-of-use-and-privacy-policy/",
  },
  {
    label: "Terms of Service",
    href: "https://www.hotelinking.com/en/terms-and-policies/hotelinking-terms-and-conditions/",
  },
  {
    label: "Legal Notice",
    href: "https://www.hotelinking.com/en/legal-notice/",
  },
];

/**
 * Legal links and copyright under the form. On a reseller's login the
 * copyright names the reseller; the legal links stay Hotelinking's, since
 * Hotelinking still runs the service and processes the data.
 */
export function AuthFooter() {
  const currentYear = new Date().getFullYear();
  const owner = useResellerBranding()?.displayName ?? "Hotelinking";

  return (
    <footer className="mt-8 pt-4 border-t border-[hsl(40_10%_91%_/_0.6)] text-center">
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-[hsl(24_10%_40%)] mb-2">
        {LEGAL_LINKS.map((link, i) => (
          <span key={link.href} className="inline-flex items-center gap-x-4">
            {i > 0 && (
              <span className="text-[hsl(40_10%_91%)]" aria-hidden="true">
                &bull;
              </span>
            )}
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[hsl(24_10%_10%)] transition-colors"
            >
              {link.label}
            </a>
          </span>
        ))}
      </nav>
      <p className="text-xs text-[hsl(24_10%_40%)]">
        {/* One text node after the year, as before resellers: splitting it
            at the name changes Chrome's kerning and every screen's pixels. */}
        &copy; {currentYear}
        {` ${owner}. All rights reserved.`}
      </p>
    </footer>
  );
}
